import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Category } from "../../models/category";
import { CategoryService } from "../../services/category.service";
import { RouterLink } from "@angular/router";
import { SearchComponent } from "./search/search.component";
import { ClickOutsideDirective } from "../../click-outside.directive";
import { NgIf, NgFor } from "@angular/common";

@Component({
    selector: "fw-toolbar",
    templateUrl: "./toolbar.component.html",
    styleUrls: ["./toolbar.component.scss"],
    imports: [RouterLink, SearchComponent, ClickOutsideDirective, NgIf, NgFor]
})
export class ToolbarComponent implements OnInit {
  mobileMenuOpened: boolean = false;
  catMenuOpened: boolean = false;

  @Output() toggledSidebar = new EventEmitter<boolean>();

  public cats: Category[];
  public menu: any;

  constructor(private catSrv: CategoryService) {}

  toggleSidebar() {
    this.toggledSidebar.emit(true);
  }

  onCatMenuToggle() {
    this.catMenuOpened = !this.catMenuOpened;
  }

  onMobileMenuToggle() {
    this.mobileMenuOpened = !this.mobileMenuOpened;
  }

  ngOnInit() {
    this.catSrv.allByProjectId(1).subscribe((cats) => {
      this.cats = cats["categories"].filter((cat) => cat.id !== 156);
    });
  }
}
